import React from 'react';
import styled from 'styled-components'
import { Link } from 'react-router-dom'
import {useReactiveVar} from "@apollo/client";

import {isApiVar} from "../../cache"


const Navigation = (props) => {
  const isApi = useReactiveVar(isApiVar);

  return(
    <Wrapper isApi={isApi}>
      <Link to={`/`}>
        <Logo alt="" src="../../logoFull.png" />
      </Link>  
      <Link to={`/`}>
        <LogoMobile alt="" src="../../logoSmall.png" />
      </Link>  
      <LinksWrapper>
        <Link 
          to={`privacy-policy`}
          style={{textDecoration:"none"}}
        >
          <LinkWrapper onClick={()=>window.scrollTo(0, 0)}>
            Privacy policy
          </LinkWrapper>
        </Link>  
        <LinkWrapper isApi={isApi} onClick={()=>window.open("https://www.instagram.com/onlineartexhibitionspace")} >
          Instagram
        </LinkWrapper>
        <LinkWrapper isApi={isApi}>
          Copyright © 2021
        </LinkWrapper> 
      </LinksWrapper>
    </Wrapper>
  )
}

export default Navigation


const Logo = styled.img(props => ({
  width:300,
  cursor:"pointer",
  "@media (max-width: 650px)": {
    display:"none",
  }
}));

const LogoMobile = styled.img(props => ({
  width:64,
  marginTop:32,
  cursor:"pointer",
  "@media (min-width: 651px)": {
    display:"none",
  }
}));


const LinksWrapper = styled.div(props => ({
  display:"flex",
  alignItems:"center",
  justifyContent:"flex-end",
  flexGrow:10,
  "@media (max-width: 840px)": {
    flexDirection:"column",
    alignItems:"flex-end",
  },
  "@media (max-width: 650px)": {
    alignItems:"center",
  }
}));

const Wrapper = styled.div(props => ({
  borderTop:"1px solid rgba(0, 0, 0, 0.1)",
  display: props.isApi ? "none" : "flex",
  paddingLeft:100,
  paddingRight:100,
  justifyContent:"space-between",
  alignItems:"center",
  height:200,
  "@media (max-width: 980px)": {
    paddingLeft:50,
    paddingRight:50,
  },
  "@media (max-width: 650px)": {
    height:"auto",
    padding:"46px 16px",
    flexDirection:"column-reverse",
  }
}));

const LinkWrapper = styled.div(props => ({
  width:200,
  display:"flex",
  justifyContent:"center",
  fontWeight: 500,
  fontSize: "14px",
  lineHeight: "100%",
  fontStyle: "normal",
  alignItems:"center",
  cursor:"pointer",
  maxHeight:18,
  borderRadius:0,
  textDecoration:"none",
  whiteSpace: "nowrap",
  transition:"0.2s linear",
  color: props.isApi ? "#949494" : "#2A2A2A",
  position:"relative",
  "@media (max-width: 1100px)": {
    width:"auto",
    marginLeft:24,
    fontSize: "12px",
  },
  "@media (max-width: 840px)": {
    margin:"4px 0px",
  },
  "@media (max-width: 650px)": {
    margin:"16px 0px",
  }
}));
